

export const AppConstant = {
    Tenant: "testing",
    varsion: 1.00,
    // Appcolor:"#3C2A21",
    Appcolor: "#6C5F5B",
// #f9fafc
    bulecolor: "#0A1733",
    orangecolor: "#F37021",
    textgrey: "grey",
    mainscrncolor: '#f9fafc',
    backgroundtextilerdesign: 'url("https://www.transparenttextures.com/patterns/asfalt-dark.png")',
    backgroundAttachmentscroller: "fixed",
    // backgroundtextilerdesign:'url("https://www.transparenttextures.com/patterns/graphy.png")',


}